package org.catharsis.spendtel

import dev.gitlive.firebase.storage.File

class WebPlatform : Platform {
    override val name: String = "Web"
}

actual fun getPlatform(): Platform = WebPlatform()

actual fun onApplicationStartPlatformSpecific() {
    // No mobile push-notification setup required on web.
}

actual fun createTempFileFromByteArray(fileByteArray: ByteArray): File {
    val fileName = "temp_${kotlin.random.Random.nextLong()}.tmp"
    return File(arrayOf(fileByteArray), fileName)
}
